import * as types from './constants';

export const listCustomerProductRatings = () => ({
  type: types.CUSTOMER_PRODUCT_RATING_LIST_REQUEST
});

export const likeCustomerProduct = (productId) => ({
  type: types.CUSTOMER_PRODUCT_RATING_LIKE_REQUEST,
  productId
});

export const dislikeCustomerProduct = (productId) => ({
  type: types.CUSTOMER_PRODUCT_RATING_DISLIKE_REQUEST,
  productId
});

export const deleteProductRating = (productId) => ({
  type: types.CUSTOMER_PRODUCT_RATING_DELETE_REQUEST,
  productId
});
